/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import * as types from '../constants';

const INITIALSTATE = {
    data: [],
};

export default function seasonReducer(state = INITIALSTATE, action) {
    switch (action.type) {
        case types.GET_SEASONS:
            return {
                ...state,
                data: action.payload,
                error: undefined,
            };
        case types.GET_SEASONS_ERR:
            return {
                ...state,
                data: [],
                error: action.error,
            };
        default:
            return state;
    }
}
